// @flow

import assert from "assert";
import * as React from "react";

import Page from "../../components/Page/Page";
import ProjectControls from "../../components/ProjectControls/ProjectControls";
import WithLoadingIndicator from "../../components/WithLoadingIndicator/WithLoadingIndicator";
import templates from "../../templates/";
import type { ProjectType } from "../../data/projects";
import type { userQueryResult } from "../../data/accounts";
import type { retrieveProjectQueryResult } from "../../data/project";
import { withRetrieveProject } from "../../data/project";

import WithTracker from "../../components/WithTracker/WithTracker";

type Props = {
  projectId: string
} & userQueryResult &
  retrieveProjectQueryResult;

const Project = (props: Props) => {
  const projectId = props.projectId;
  const project: ProjectType = props.projectData.Project;
  const template = templates[project.template];
  assert.ok(template, "Template not found");

  return (
    <Page className="Project">
      <template.instructions />
      <ProjectControls projectId={projectId} userData={props.userData} />
    </Page>
  );
};

export default WithTracker(withRetrieveProject(WithLoadingIndicator(Project)));



// WEBPACK FOOTER //
// ./src/pages/Project/Project.js